import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { IconButton } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Radio, RadioGroup,TextField ,FormLabel,FormControlLabel} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import {  FormGroup, Typography,   ClickAwayListener,ListItemText 
 } from "@mui/material";
 import DeleteIcon from "@mui/icons-material/Delete";
  import MedicalAbstractBackground from "./MedicalAbstractBackground ";
  
 import {Autocomplete,} from "@mui/material";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  StepConnector,
  stepConnectorClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Checkbox, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { keyframes } from "@mui/system";
import Pagination from "@mui/material/Pagination";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { Country, State, City } from "country-state-city";
import { formatDateDDMMYYYY } from "utils/dateFormatter";
import "../styles/form-labels.css";

function CreateDoctorsProfile() {
   const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;
    const getCurrentDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
   const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;

    const [mappingList, setMappingList] = useState([]);
const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"

  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
const [openDelearModal, setOpenDelearModal] = useState(false);
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState("");
  const [devicename, setDevicename] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [devices, setDevices] = useState([]);
  const [showCustomFields, setShowCustomFields] = useState(false);
  const [customerTypes, setCustomerTypes] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldData, setCustomFieldData] = useState({});
  const [showDocuments, setShowDocuments] = useState(false);
const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [specializationList, setSpecializationList] = useState([]);
  const [counsilList, setCounsilList] = useState([]);
    const [doctorList, setDoctorList] = useState([]);

  const [activeStep, setActiveStep] = useState(0);

  const [customerDetails, setCustomerDetails  ] = useState({
    username: "",
    role: "",
    doctorRegistration: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phone: "",
     countryCode: "+91",

     age:"",
     martialStatus:"",
     gender:"",
     dob:"",
     address:"",
     address1:"",
     district:"",
    state:"",
    country:"",
    pin:"",
    nmcRegisteredNumber:"",
    yearOfRegistration:"",
    hospitalAddresses: [],
    hospitalId:"",
verificationstatus:"",
    },
     specialization:[],
     counsil:[ ],
    document:[
    //  {
    //   documentname: "",
    //   documenttype: "",
    //   dateofupload: getCurrentDate(),
    //   imageMeta: "",
    //   image: "",
    // },
    ],
  });
const countryCodes = [
  { code: "+91", name: "India" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
  { code: "+61", name: "Australia" },
  { code: "+971", name: "UAE" },
];
const countryPhoneRules = {
  "+91": 10, // India
  "+1": 10,  // USA / Canada
  "+44": 10, // UK
  "+61": 9,  // Australia
  "+971": 9, // UAE
};
const countryPhonePatterns = {
  "+91": /^[6-9]\d{9}$/, // India: must start with 6–9 and be 10 digits
  "+1": /^[2-9]\d{9}$/,  // USA: first digit cannot be 0 or 1
  "+44": /^\d{10}$/,     // UK: 10 digits
  "+61": /^\d{9}$/,      // Australia: 9 digits
  "+971": /^\d{9}$/,     // UAE: 9 digits
};
     const [formErrors, setFormErrors] = useState({});

   
  const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
const validatePhoneNumber = (phone) => {
  const regex = /^[0-9]{10}$/; // exactly 10 digits
  return regex.test(phone.trim());
};
// const validateNMCNumber =(nmcNumber)  =>{
//   const errors = {};

//   if (!nmcNumber || !nmcNumber.toString().trim()) {
//     errors.nmcRegisteredNumber = "NMC Registered Number is required";
//   } else {
//     const regex = /^[A-Za-z0-9]+$/;
//     if (!regex.test(nmcNumber)) {
//       errors.nmcRegisteredNumber = "NMC Registered Number must be alphanumeric";
//     }

//     const len = nmcNumber.toString().length;
//     if (len < 6 || len > 12) {
//       errors.nmcRegisteredNumber = "NMC Registered Number must be 6–12 characters long";
//     }
//   }

//   return errors;
// }

 useEffect(() => {
    setCountries(Country.getAllCountries()); // all countries
  }, []);

  // when country changes → update states
  const handleCountryChange = (countryCode) => {
    setCustomerDetails({
      ...customerDetails,
      doctorRegistration: { ...customerDetails.doctorRegistration, country: countryCode, state: "", district: "" },
    });
    setStates(State.getStatesOfCountry(countryCode));
    setDistricts([]); // reset districts
  };

  // when state changes → update districts
  const handleStateChange = (stateCode) => {
    setCustomerDetails({
      ...customerDetails,
      doctorRegistration: { ...customerDetails.doctorRegistration, state: stateCode, district: "" },
    });
    setDistricts(City.getCitiesOfState(customerDetails.doctorRegistration.country, stateCode));
  };

   const fetchSpecializations = async () => {
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/specializationList", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setSpecializationList(decryptedData || []);
        console.log("Specialization List:", decryptedData.content);
      }
    } catch (error) {
      console.error("Error fetching specialists:", error);
    } finally {
      setLoading(false);
    }
  };

 const fetchCounsilNames = async () => {
    try {
      setLoading(true);
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/counsilNames", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setCounsilList(decryptedData|| []);
      }
    } catch (error) {
      console.error("Error fetching counsil names:", error);
    } finally {
      setLoading(false);
    }
  };

   const fetchDoctorType = async () => {
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get("/api/doctortype", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setDoctorList(decryptedData || []);
        console.log("Specialization List:", decryptedData.content);
      }
    } catch (error) {
      console.error("Error fetching specialists:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSpecializations();
    fetchCounsilNames();
    fetchDoctorType();
  }, []);

  

 const handleAddDocument = () => {
  setCustomerDetails((prev) => ({
    ...prev,
    document: [
      ...prev.document,
      {
        documentname: "",
        documenttype: "",
        dateofupload: getCurrentDate(),
        imageMeta: "",
        image: "",
      },
    ],
  }));
};



  const [customersList, setCustomersList] = useState([]);  
  const navigate = useNavigate();
  const fetchMapping = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/hospitalprofile/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData || []);
       
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMapping();
  }, []);
//  const validateForm = () => {
//   const errors = {};

//   const { coordinator, username } = customerDetails;

//   if (!coordinator.firstname.trim()) errors.firstname = "First Name is required";
//   if (!coordinator.lastname.trim()) errors.lastname = "Last Name is required";
// if (!username.trim()) {
//   errors.username = "Email is required";
// } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)) {
//   errors.username = "Invalid email format";
// } if (!coordinator.phone.trim()) {
//     errors.phone = "Phone number is required";
//   } else if (!validatePhoneNumber(coordinator.phone)) {
//     errors.phone = "Phone number must be 10 digits";
//   } 
//    if (!coordinator.nmcRegisteredNumber.trim()) errors.nmcRegisteredNumber = "NMC Registered Number is required";
//   else if (!validateNMCNumber(coordinator.nmcRegisteredNumber)) errors.nmcRegisteredNumber = " Invalid NMC Registered Number  format";

//   if (!coordinator.hospitalAddress.trim()) errors.hospitalAddress = "Hospital Address is required";
//  if (!coordinator.dob.trim()) {
//     errors.dob = "Date of Birth is required";
//   } else {
//     const dob = new Date(coordinator.dob);
//     const today = new Date();
//     if (dob > today) {
//       errors.dob = "Date of Birth cannot be in the future";
//     }
//   }
//     if (!coordinator.address?.trim()) errors.addressLine1 = "Address Line 1 is required";
//   if (!coordinator.city?.trim()) errors.city = "City is required";
//   if (!coordinator.state?.trim()) errors.state = "State is required";
//   if (!coordinator.country?.trim()) errors.country = "Country is required";
//   if (!coordinator.pincode?.trim()) errors.pincode = "Postal Code is required";
//   if (!coordinator.locationid) errors.locationid = "Location is required";
//   if (!coordinator.gender.trim()) errors.gender = "Gender is required";
//   if (!coordinator.martialStatus.trim()) errors.martialStatus = "Marital Status is required";
//  if (!coordinator.yearOfRegistration.trim()) {
//     errors.yearOfRegistration = "Year Of Registration is required";
//   } 
//   setFormErrors(errors);
//   return Object.keys(errors).length === 0;
// };
const validateDocuments = () => {
  let hasError = false;
  const updatedDocs = [...customerDetails.document];
   console.log("Customer documents before validation:", updatedDocs);
  // ✅ 1️⃣ Case-insensitive duplicate check
  const docNames = updatedDocs.map((d) => d.documentname?.toLowerCase().trim());
  const duplicates = docNames.filter((item, index) => docNames.indexOf(item) !== index);
  //console.log("duplicates values:", duplicates);
  if (duplicates.length > 0) {
    toast.error(`Duplicate document uploaded: ${duplicates[0]}`);
    hasError = true;
  }

  // ✅ 2️⃣ Case-insensitive required document check
  const requiredDocs = ["Aadhar Card", "Pan Card", "Driving License", "Study Certificate"];
  requiredDocs.forEach((docName) => {
    let doc = updatedDocs.find(
      (d) => d.documentname?.toLowerCase().trim() === docName.toLowerCase().trim()
    );
    let idx = updatedDocs.findIndex(
      (d) => d.documentname?.toLowerCase().trim() === docName.toLowerCase().trim()
    );

    // If required doc missing, add placeholder
    if (!doc) {
      doc = { documentname: docName, documenttype: "", dateofupload: "", image: "", errors: {} };
      updatedDocs.push(doc);
      idx = updatedDocs.length - 1;
    }

    const errors = {};

    // ✅ 3️⃣ Check multiple possible image fields (image, file, imagePath, url)
    if (!doc.image && !doc.file && !doc.imagePath && !doc.url) {
      errors.image = "File upload is required";
    }

    if (Object.keys(errors).length > 0) {
      toast.error(`${docName} is required with File.`);
      hasError = true;
    }

    updatedDocs[idx].errors = errors;
  });

  setCustomerDetails({ ...customerDetails, document: updatedDocs });
  return !hasError;
};




  const handleSubmit = async (e) => {
    
    e.preventDefault();
//  const areDocsValid = validateDocuments();

//   if (areDocsValid !== true) {
//     console.log("❌ Validation failed. Stopping API trigger.");
//     // toast.error("Please fix the errors highlighted in red.");
//     return; // 🚫 STOP here — API will never trigger
//   }
// //      const requiredDocs = ["Aadhar Card", "Pan Card", "Driving License",   "Study Certificate"
// ];

//   let hasError = false;
//   requiredDocs.forEach((docName) => {
//     const exists = customerDetails.document.some(
//       (d) =>
//         d.documentname === docName &&
//         d.image &&
//         d.imageMeta &&
//         d.dateofupload
//     );

//     if (!exists) {
//     toast.error(`${docName} is required.`);
//       hasError = true;
//     }
//   });

//   if (hasError) {
//     return; // Stop submission if any required doc is missing
//   }
     
    const docsValid = validateDocuments();
  if (!docsValid) {
    toast.error("Please upload the required documents before submitting.");
    return;
  }

    setLoading(true);
    try {
      
      const secretKey = await fetchSecretKey();
    
      const formatDoctorName = (name) => {
  if (!name) return "";
  return name.toLowerCase().startsWith("dr")
    ? name
    : `Dr. ${name}`;
};

      const rawPayload = {
        username: customerDetails.username,
        role: "ROLE_DOCTOR",

        doctorRegistration: {

firstname: formatDoctorName(customerDetails.doctorRegistration.firstname),
          lastname: customerDetails.doctorRegistration.lastname,
          imageMeta: customerDetails.doctorRegistration.imageMeta,
    image: customerDetails.doctorRegistration.image,
      phoneNumber: `${customerDetails.doctorRegistration.phone}`, // country first
      phonecountrycode:`${customerDetails.doctorRegistration.countryCode}`,
    age: customerDetails.doctorRegistration.age,
    martialStatus: customerDetails.doctorRegistration.martialStatus,
    gender: customerDetails.doctorRegistration.gender,
    dob: formatDateDDMMYYYY(customerDetails.doctorRegistration.dob),
    address: customerDetails.doctorRegistration.address,
    address1: customerDetails.doctorRegistration.address1,
    city: customerDetails.doctorRegistration.district,
    state: customerDetails.doctorRegistration.state,
    country: customerDetails.doctorRegistration.country,
    pin: customerDetails.doctorRegistration.pin,
    nmcRegisteredNumber: customerDetails.doctorRegistration.nmcRegisteredNumber,
    yearOfRegistration: formatDateDDMMYYYY(customerDetails.doctorRegistration.yearOfRegistration),

  //  hospitalId: customerDetails.doctorRegistration.hospitalId, // ✅ added here

    verificationstatus: customerDetails.doctorRegistration.verificationstatus,
      doctorType: customerDetails.doctorRegistration.doctorType,

        },
// hospitals: customerDetails.doctorRegistration.hospitalAddresses.map((id) => ({
//   hospitalId: id,
// })),
hospitalIds: customerDetails.doctorRegistration.hospitalAddresses,

         specialization: customerDetails.specialization?.map((s) => ({
        doctorspecialization: s.doctorspecialization,
      })),

      counsil: customerDetails.counsil?.map((c) => ({
        doctorCounsilNames: c.doctorCounsilNames,
      })),
document: customerDetails.document?.map((doc) => ({
    documentname: doc.documentname,
    documenttype: doc.documenttype,
   dateofupload: formatDateDDMMYYYY(doc.dateofupload ? doc.dateofupload : currentDate),
    imageMeta: doc.imageMeta,
    image: doc.image,
  })),

      };
  
      console.log("Raw Payload Before Encryption:", rawPayload); 
  
      const encryptedData = encryptBody(rawPayload, secretKey);
  
      console.log("Encrypted Payload:", encryptedData);
  
      const token = JSON.parse(localStorage.getItem("loginData")).token;
  
      // Register Dealer
      const response = await axios.post("/api/doctor/register", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        console.log("Decrypted Response:", decryptedResponse);

  
        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }
  
        if (decryptedResponse.success === true) {
          
          toast.success(decryptedResponse.message || "Doctor Profile Created successfully!");
          navigate(-1);
          setTimeout(() => {
            toast.info("Password has been sent to your email.");
          }, 1500);
          const dealerid = decryptedResponse?.dealerid; 
  
          // if (dealerid && deviceId) {
          //   await mapDealerToDevice(dealerid, deviceId, token);
          // }
  
          // Reset the form and update UI
          setCustomersList
((prevDealers) => [
            ...prevDealers,
            {
             firstname: customerDetails.doctorRegistration.firstname,
          lastname: customerDetails.doctorRegistration.lastname,
          imageMeta: customerDetails.doctorRegistration.imageMeta,
    image: customerDetails.doctorRegistration.image,
    phone: customerDetails.doctorRegistration.phone,
    locationid: customerDetails.doctorRegistration.locationid,
    age: customerDetails.doctorRegistration.age,
    martialStatus: customerDetails.doctorRegistration.martialStatus,
    gender: customerDetails.doctorRegistration.gender,
    certificationvalidtill: customerDetails.doctorRegistration.certificationvalidtill,
    dob: customerDetails.doctorRegistration.dob,
  
         
            },
          ]);
  
          setCustomerDetails
({
            username: "",
    role: "",
    doctorRegistration: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phone: "",
     locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     dob:"",
    address:"",
    address1:"",
        district:"",
    state:"",
    country:"",
    pin:"",
    nmcRegisteredNumber:"",
    yearOfRegistration:"",
    hospitalAddress:"",
verificationstatus:"",
    },
     specialization:[],
     counsil:[ ],
    document:[
    //  {
    //   documentname: "",
    //   documenttype: "",
    //   dateofupload: "",
    //   imageMeta: "",
    //   image: "",
    // },
    ],
          });
  

        } else {
          toast.error(decryptedResponse?.message || "Failed to verify registration.");
        }
      }
    } catch (error) {
  console.error("Registration Error:", error);

 if (error.response) {
  const backendMessage = error.response.data?.message;

  if (error.response.status === 500) {
    toast.error(backendMessage || "This email is already registered");
  } else {
    toast.error(backendMessage || "Registration failed");
  }
}
} finally {
  setLoading(false);
}
  };
  
  
 

  

 
  const handleCancel = () => {
    setCustomerDetails
({
     username: "",
    role: "",
    doctorRegistration: {
      id: "",
      firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phone: "",
     address:"",
    address1:"",
        district:"",
    state:"",
    country:"",
    pin:"",
     age:"",
     martialStatus:"",
     gender:"",
     dob:"",
    address:"",
    address1:"",
        district:"",
    state:"",
    country:"",
    pin:"",
    nmcRegisteredNumber:"",
    yearOfRegistration:"",
    hospitalAddress:"",
verificationstatus:"",
    },
     specialization:[],
     counsil:[ ],
    document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload: "",
      imageMeta: "",
      image: "",
    },
    ],
    });
    navigate(-1); 
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];
// const validateNMCNumber = async (nmcNumber) => {
//   try {
//     const response = await fetch(`https://api.nmc.org.in/validate/${nmcNumber}`);
//     const data = await response.json();

//     if (!data.valid) {
//       return "Invalid NMC Registration Number";
//     }
//     return null; // No error
//   } catch (error) {
//     return "Unable to validate NMC number. Please try again later.";
//   }
// };

  const steps = ["Personal Info", "Address Info", "Professional Details", "Documents"];
const validateStep0 = () => {
 const errors = {};
   const code = customerDetails.doctorRegistration?.countryCode || "+91";
  const phone = customerDetails.doctorRegistration?.phone?.trim() || "";

  const { doctorRegistration, username } = customerDetails;
  const reg = customerDetails.doctorRegistration;
   const nameRegex = /^[A-Za-z\s]+$/;
  const usernameRegex = /^[a-zA-Z0-9_]+$/;
const countryPhonePatterns = {
    "+91": /^[6-9]\d{9}$/, // India
    "+1": /^[2-9]\d{9}$/,  // USA
    "+44": /^\d{10}$/,     // UK
    "+61": /^\d{9}$/       // Australia
  };

  const countryPhoneRules = {
    "+91": 10,
    "+1": 10,
    "+44": 10,
    "+61": 9
  };

  const expectedLength = countryPhoneRules[code] || 10;
  const pattern = countryPhonePatterns[code];
  if (!phone) {
    errors.phone = "Phone number is required";
  } else if (!/^\d+$/.test(phone)) {
    errors.phone = "Phone number must contain only digits";
  } else if (phone.length !== expectedLength) {
    errors.phone = `Invalid phone number length for ${code}. Expected ${expectedLength} digits.`;
  } else if (pattern && !pattern.test(phone)) {
    errors.phone = `Invalid phone number format for ${code}`;
  } else if (!pattern && (phone.length < 6 || phone.length > 15)) {
    errors.phone = `Invalid phone number format for ${code}`;
  }

  // ✅ Country code validation
  if (!reg.countryCode || reg.countryCode.trim() === "") {
    errors.phone = "Country code is required";
  }

 if (!reg || !reg.firstname || !reg.firstname.trim()) {
    errors.firstname = "First Name is required";
  } else if (!nameRegex.test(reg.firstname.trim())) {
    errors.firstname = "First Name should contain only alphabets (no numbers or special characters)";
  } else if (reg.firstname.trim().length < 2) {
    errors.firstname = "First Name must be at least 2 characters long";
  }

  // --- Last Name ---
  if (!reg || !reg.lastname || !reg.lastname.trim()) {
    errors.lastname = "Last Name is required";
  } else if (!nameRegex.test(reg.lastname.trim())) {
    errors.lastname = "Last Name should contain only alphabets (no numbers or special characters)";
  }
  if (!customerDetails.username.trim()) errors.username = "Email is required";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerDetails.username))
    errors.username = "Invalid email format";
  if (!reg.phone.trim()) errors.phone = "Phone number is required";
  else if (!validatePhoneNumber(reg.phone))
    errors.phone = "Phone number must be 10 digits";
  if (!reg.gender) errors.gender = "Gender is required";
  if (!reg.martialStatus) errors.martialStatus = "Marital Status is required";
if (!reg.dob) {
    errors.dob = "Date of Birth is required";
  } else {
    const dobDate = new Date(reg.dob);
    const today = new Date();
    if (dobDate > today) {
      errors.dob = "Date of Birth cannot be a future date";
    }
  }
  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};

const validateStep1 = () => {
  const errors = {};
  const reg = customerDetails.doctorRegistration;

  if (!reg.address?.trim()) errors.address = "Address is required";
  if (!reg.country) errors.country = "Country is required";
  if (!reg.state) errors.state = "State is required";
  if (!reg.district) errors.district = "District is required";
  if (!reg.pin?.trim()) errors.pin = "Postal Code is required";

  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};

const validateStep2 = () => {
  const errors = {};
  const reg = customerDetails.doctorRegistration;

const value = reg.nmcRegisteredNumber?.trim() || "";

if (!value) {
  errors.nmcRegisteredNumber = "NMC Registered Number is required";
} else if (!/^[0-9]+$/.test(value)) {
  errors.nmcRegisteredNumber = "NMC Registered Number must be numeric";
}

if (!reg.hospitalAddresses || reg.hospitalAddresses.length === 0) {
  errors.hospitalAddresses = "Select at least one hospital";
}
  if (!reg.yearOfRegistration) errors.yearOfRegistration = "Year Of Registration is required";
  if (!reg.doctorType) errors.doctorType = " Select Doctor Type ";
    if (!reg.verificationstatus) errors.verificationstatus= " Select Verification Status ";

  // if (customerDetails.specialization.length === 0)
  //   errors.specialization = "Select at least one specialization";

  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};
  const handleNext = () => {
  let valid = false;

  if (activeStep === 0) {
    valid = validateStep0(); // Personal Info
  } else if (activeStep === 1) {
    valid = validateStep1(); // Address Info
  } else if (activeStep === 2) {
    valid = validateStep2(); // Professional Info
  } else if (activeStep === 3) {
    valid = validateDocuments(); // Documents
  }

  if (valid) {
    if (activeStep < steps.length - 1) setActiveStep((prev) => prev + 1);
    else handleSubmit(); // Final submit
  }
};

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };

 const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: "20px",
    left: 38,
    right: 170,
    marginLeft: "-100px",
    marginRight: "10px",
    position: "absolute",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#1976d2",
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const CustomStepper = styled(Stepper)(() => ({
  background: "transparent",
  padding: "1.5rem 0 1rem",
  boxShadow: "none",
  marginBottom: "32px",
  width: "100%",
}));

// Custom Step Icon
const StepIconContainer = styled("div")(({ ownerState }) => ({
  backgroundColor: ownerState.active
    ? "#516dd3" // Active = Blue
    : ownerState.completed
    ? "#2f995e" // Completed = Green
    : "#b0b5b7", // Inactive = Grey
  color: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px 12px",
  borderRadius: "50px", // pill shape
  fontSize: "12px",
  fontWeight: "bold",
  textAlign: "center",
  minWidth: "120px", // ensures pill box width
  boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
}));

function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;
  const ownerState = { active, completed };

  // Map step numbers to your custom labels
  const stepLabels = [
    "Personal Info",
    "Address Info",
    "Professional Info",
    "Documents Upload",
  ];

  return (
    <StepIconContainer ownerState={ownerState} className={className}>
      {stepLabels[Number(icon) - 1]} 
    </StepIconContainer>
  );
}


  return (
    <DashboardLayout>
      <DashboardNavbar />
           <MedicalAbstractBackground/>
      
      {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                        backgroundColor:"#1A237E", 
                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
      

     

        
        <Card sx={{ width: "1000px", maxWidth: "1200px", padding: 3 }}>
          <MDBox pt={4} pb={3} px={3}>
           <CustomStepper
  alternativeLabel
  activeStep={activeStep}
  connector={<CustomConnector />}
>
  {steps.map((label, index) => (
    <Step key={label}>
      <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
    </Step>
  ))}
</CustomStepper>


<form onSubmit={handleSubmit}>
            <MDTypography  sx={{  marginBottom: "20px",   textAlign: "center",fontSize: "15px", fontWeight: "bold", marginBottom: "10px" }}>Create Doctor Profile</MDTypography>

              <Grid container spacing={2}>

                {/* Profile Photo Upload */}
<Grid item xs={12} style={{ textAlign: "center" }}>
  {customerDetails.doctorRegistration?.image && (
    <img
      src={`data:image/*;base64,${customerDetails.doctorRegistration.image}`}
      alt="Profile Preview"
      style={{
        width: "120px",
        height: "120px",
        borderRadius: "50%",
        objectFit: "cover",
        marginBottom: "10px",
      }}
    />
  )}

  {/* Upload Button */}
  <input
    accept="image/*"
    style={{ display: "none" }}
    id="upload-profile-photo"
    type="file"
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setCustomerDetails({
            ...customerDetails,
            doctorRegistration: {
              ...customerDetails.doctorRegistration,
              imageMeta: file.name,
              image: reader.result.split(",")[1], // base64
            },
          });
        };
        reader.readAsDataURL(file);
      }
    }}
  />
  <br/>
  <label htmlFor="upload-profile-photo">
    <MDButton
      component="span"
      style={{
        backgroundColor:"#1A237E",
        color: "#fff",
        textTransform: "none",
        minWidth: "160px",   // reduced length
        height: "36px",
      }}
    >
      Upload Profile Photo
    </MDButton>
  </label>
</Grid>
          <Grid container spacing={2}>
    {activeStep === 0 && (
              <>
          <Grid item xs={12}>
    <h3>Personal Information</h3>
  </Grid>

        <Grid item xs={6}>
          <MDInput
            type="text"
            label="First Name"
            fullWidth
            value={customerDetails.doctorRegistration?.firstname|| ""}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, doctorRegistration: { ...customerDetails.doctorRegistration, firstname: e.target.value } })
            }
            
            
          />
           {formErrors.firstname && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.firstname}
            </Typography>
          )}
        </Grid>
         <Grid item xs={6}>
          <MDInput
            type="text"
            label="Last Name"
            fullWidth
            value={customerDetails.doctorRegistration?.lastname}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, doctorRegistration: { ...customerDetails.doctorRegistration, lastname: e.target.value } })
            }
            
            
          />
        </Grid>
        <Grid item xs={6}>
          <MDInput
            type="email"
            label="Email"
            fullWidth
            value={customerDetails?.username}
            onChange={(e) => setCustomerDetails
                ({ ...customerDetails, username: e.target.value })}
            
          />
           {formErrors.username && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.username}
            </Typography>
          )}
        </Grid>
       <Grid item xs={6}>
         <Grid container spacing={1}>
           <Grid item xs={4}>
             <MDInput
               select
               label="Country Code"
               fullWidth
               value={customerDetails.doctorRegistration?.countryCode || "+91"}
               onChange={(e) =>
                 setCustomerDetails({
                   ...customerDetails,
                   doctorRegistration: {
                     ...customerDetails.doctorRegistration,
                     countryCode: e.target.value,
                   },
                 })
               }
               sx={{
                 "& .MuiInputBase-root": {
                   height: "45px",
                 },
               }}
             >
               {countryCodes.map((item) => (
                 <MenuItem key={item.code} value={item.code}>
                   {`${item.name} (${item.code})`}
                 </MenuItem>
               ))}
             </MDInput>
           </Grid>
               {/* Phone Number Input */}
        <Grid item xs={8}>
  <MDInput
    type="text"
    label="Phone Number"
    fullWidth
    value={customerDetails.doctorRegistration?.phone || ""}
   onChange={(e) => {
      const code = customerDetails.doctorRegistration?.countryCode || "+91";
      const maxLength = countryPhoneRules[code] || 10;
      const value = e.target.value.replace(/\D/g, ""); // only digits
      if (value.length <= maxLength) {
        setCustomerDetails({
          ...customerDetails,
          doctorRegistration: {
            ...customerDetails.doctorRegistration,
            phone: value,
          },
        });
      }
    }}
       onBlur={() => {
      const phone = customerDetails.doctorRegistration?.phone || "";
      const code = customerDetails.doctorRegistration?.countryCode || "+91";
      const expectedLength = countryPhoneRules[code] || 10;
      const pattern = countryPhonePatterns[code];

      if (phone.length !== expectedLength) {
        setFormErrors((prev) => ({
          ...prev,
          phoneNumber: `Phone number must be exactly ${expectedLength} digits for ${code}`,
        }));
      } else if (!pattern.test(phone)) {
        setFormErrors((prev) => ({
          ...prev,
          phoneNumber: `Invalid phone number format for ${code}`,
        }));
      } else {
        setFormErrors((prev) => ({ ...prev, phone: "" }));
      }
    }}
      />
    </Grid>
  </Grid>

  {/* Error Message */}
 {formErrors.phone ? (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.phone}
  </Typography>
) : (
  <Typography sx={{ fontSize: "12px", color: "gray", mt: 0.5 }}>
    {customerDetails.doctorRegistration?.countryCode === "+91"
      ? "Enter a 10-digit Indian number (e.g., 9876543210)"
      : `Enter ${
          countryPhoneRules[customerDetails.doctorRegistration?.countryCode || "+91"]
        } digits phone number for ${
          countryCodes.find(
            (c) => c.code === customerDetails.doctorRegistration?.countryCode
          )?.name || "selected country"
        }`}
  </Typography>
)}

</Grid>

       
      

       
       <Grid item xs={6}>
  <MDInput
    select
    label="Gender"
    fullWidth
    value={customerDetails.doctorRegistration?.gender || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: { ...customerDetails.doctorRegistration, gender: e.target.value },
      })
    }
    
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
  >
    <MenuItem value="Male">Male</MenuItem>
    <MenuItem value="Female">Female</MenuItem>
    <MenuItem value="Others">Others</MenuItem>
  </MDInput>
   {formErrors.gender && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.gender}
            </Typography>
          )}
</Grid>
      <Grid item xs={6}>
  <MDInput
    select
    label="Marital Status"
    fullWidth
    value={customerDetails.doctorRegistration?.martialStatus || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: { ...customerDetails.doctorRegistration, martialStatus: e.target.value },
      })
    }
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    
  >
    <MenuItem value="Single">Single</MenuItem>
    <MenuItem value="Married">Married</MenuItem>
    <MenuItem value="Divorced">Divorced</MenuItem>
    <MenuItem value="Widowed">Widowed</MenuItem>
  </MDInput>
   {formErrors.martialStatus && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.martialStatus}
            </Typography>
 )}
</Grid>
<Grid item xs={6}>
  <MDInput
    type="date"
    label="Date of Birth"
    fullWidth
    InputLabelProps={{ shrink: true }}
     inputProps={{
    max: today, // ✅ prevents future dates in calendar
  }}
    value={customerDetails.doctorRegistration?.dob || ""}
    onChange={(e) => {
      let dobValue = e.target.value; 
      const [year, month, day] = dobValue.split("-");
      if (year && year.length > 4) {
        dobValue = `${year.slice(0, 4)}-${month || ""}-${day || ""}`;
      }

      const age = calculateAge(dobValue);

      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: {
          ...customerDetails.doctorRegistration,
          dob: dobValue,
          age: isNaN(age) ? "" : age.toString(),
        },
      });
    }}
        // onKeyDown={(e) => e.preventDefault()}

  />
  {formErrors.dob && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.dob}
    </Typography>
  )}
</Grid>

         <Grid item xs={6}>
          <MDInput
            type="text"
            label="Age"
            fullWidth
             placeholder="Calculated from Date of Birth"
            value={customerDetails.doctorRegistration?.age}
            onChange={(e) =>
                setCustomerDetails
                ({ ...customerDetails, doctorRegistration: { ...customerDetails.doctorRegistration, age: e.target.value } })
            }
     InputProps={{ readOnly: true }}
           />
        </Grid>
         </>
            )}


                 {/* ===== Address Information Section ===== */}
                 {activeStep === 1 && (
              <>
  <Grid item xs={12}>
    <h3>Address Information</h3>
  </Grid>

  {/* Address */} 
  <Grid item xs={12}>
    <MDInput
      type="text"
      label="Address1"
      fullWidth
      value={customerDetails.doctorRegistration?.address || ""}
      onChange={(e) =>
        setCustomerDetails({
          ...customerDetails,
          doctorRegistration: { ...customerDetails.doctorRegistration, address: e.target.value },
        })
      }
      
    />
     {formErrors.address && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.address}
            </Typography>
          )}
  </Grid>

   <Grid item xs={12}>
    <MDInput
      type="text"
      label="Address2"
      fullWidth
      value={customerDetails.doctorRegistration?.address1 || ""}
      onChange={(e) =>
        setCustomerDetails({
          ...customerDetails,
          doctorRegistration: { ...customerDetails.doctorRegistration, address1: e.target.value },
        })
      }
      
    />
     {formErrors.address1 && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.address1}
            </Typography>
          )}
  </Grid>

  {/* Country */}
  {/* Country */}
<Grid item xs={4}>
  <Autocomplete
    options={countries}
    getOptionLabel={(option) => option.name}
    value={
      countries.find((c) => c.isoCode === customerDetails.doctorRegistration?.country) ||
      null
    }
    onChange={(e, value) => handleCountryChange(value?.isoCode || "")}
    renderInput={(params) => <TextField {...params} label="Country" fullWidth />}
  />
  {formErrors.country && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.country}
    </Typography>
  )}
</Grid>

{/* State */}
<Grid item xs={4}>
  <Autocomplete
    options={states}
    getOptionLabel={(option) => option.name}
    value={
      states.find((s) => s.isoCode === customerDetails.doctorRegistration?.state) ||
      null
    }
    onChange={(e, value) => handleStateChange(value?.isoCode || "")}
    renderInput={(params) => <TextField {...params} label="State" fullWidth />}
  />
  {formErrors.state && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.state}
    </Typography>
  )}
</Grid>

{/* District */}
<Grid item xs={4}>
  <Autocomplete
    options={districts}
    getOptionLabel={(option) => option.name}
    value={
      districts.find((d) => d.name === customerDetails.doctorRegistration?.district) ||
      null
    }
    onChange={(e, value) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: {
          ...customerDetails.doctorRegistration,
          district: value?.name || "",
        },
      })
    }
    renderInput={(params) => <TextField {...params} label="District" fullWidth />}
  />
  {formErrors.district && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.district}
    </Typography>
  )}
</Grid>


  {/* Pincode */}
  <Grid item xs={6}>
    <MDInput
      type="number"
      label="Pincode"
      fullWidth
      inputProps={{ maxLength: 6 }}
      value={customerDetails.doctorRegistration?.pin || ""}
      onChange={(e) =>
        setCustomerDetails({
          ...customerDetails,
          doctorRegistration: { ...customerDetails.doctorRegistration, pin: e.target.value },
        })
      }
      
    />
     {formErrors.pin && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.pin}
            </Typography>
          )}
  </Grid>
</>
)}
  {/* ===== Professional Details Section ===== */}
   {activeStep === 2 && (
              <>
<Grid item xs={12}>
  <h3>Professional Details</h3>
</Grid>

{/* Specialist (WHO API - can be dropdown/autocomplete later) */}
{/* Specialist (WHO API - can be dropdown/autocomplete later) */}
{/* Council Names */}


{/* Specializations */}
<Grid item xs={6}>
  <TextField
    select
    label="Specializations"
    fullWidth
    SelectProps={{
      multiple: true,
      renderValue: (selected) =>
        selected.length === 0 ? "Select Specializations" : selected.join(", "),
    }}
    value={customerDetails.specialization.map((s) => s.doctorspecialization)}
    onChange={(e) => {
      const value = e.target.value;
      setCustomerDetails({
        ...customerDetails,
        specialization: value.map((val) => ({ doctorspecialization: val })),
      });
    }}
    InputProps={{
      style: { height: 45, fontSize: "0.875rem", padding: "0 12px" },
    }}
    InputLabelProps={{
      shrink: true,
      style: { fontSize: "0.875rem" },
    }}
  >
    {loading ? (
      <MenuItem disabled>Loading...</MenuItem>
    ) : specializationList.length > 0 ? (
      specializationList.map((s) => (
        <MenuItem key={s.id} value={s.specialization}>
          <Checkbox
            checked={customerDetails.specialization.some(
              (sp) => sp.doctorspecialization === s.specialization
            )}
          />
          <ListItemText
            primary={s.specialization}
            primaryTypographyProps={{ fontSize: "0.875rem" }}
          />
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No specializations available</MenuItem>
    )}
  </TextField>
</Grid>

<Grid item xs={6}>
  <TextField
    select
    label="Council Names"
    fullWidth
    SelectProps={{
      multiple: true,
      renderValue: (selected) =>
        selected.length === 0 ? "Select Council Names" : selected.join(", "),
    }}
    value={customerDetails.counsil.map((c) => c.doctorCounsilNames)}
    onChange={(e) => {
      const value = e.target.value;
      setCustomerDetails({
        ...customerDetails,
        counsil: value.map((val) => ({ doctorCounsilNames: val })),
      });
    }}
    InputProps={{
      style: { height: 45, fontSize: "0.875rem", padding: "0 12px" },
    }}
    InputLabelProps={{
      shrink: true,
      style: { fontSize: "0.875rem" },
    }}
  >
    {loading ? (
      <MenuItem disabled>Loading...</MenuItem>
    ) : counsilList.length > 0 ? (
      counsilList.map((c) => (
        <MenuItem key={c.id} value={c.counsilname}>
          <Checkbox
            checked={customerDetails.counsil.some(
              (cn) => cn.doctorCounsilNames === c.counsilname
            )}
          />
          <ListItemText
            primary={c.counsilname}
            primaryTypographyProps={{ fontSize: "0.875rem" }}
          />
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No council names available</MenuItem>
    )}
  </TextField>
</Grid>


{/* Hospital Address */}
<Grid item xs={6}>
  <MDInput
  
  select
  label="Hospital Address"
  fullWidth
  SelectProps={{
    multiple: true,
    renderValue: (selected) =>
      selected.length === 0
        ? "Select Hospital(s)"
        : mappingList
            .filter((h) => selected.includes(h.id))
            .map((h) => h.hospitalName)
            .join(", "),
  }}
  value={customerDetails.doctorRegistration?.hospitalAddresses || []}
  onChange={(e) =>
    setCustomerDetails({
      ...customerDetails,
      doctorRegistration: {
        ...customerDetails.doctorRegistration,
        hospitalAddresses: e.target.value,
      },
    })
  }
   sx={{
      "& .MuiInputBase-root": {
        height: "42px",
        fontSize: "13px",
      },
      "& .MuiInputLabel-root": {
        fontSize: "13px",
      },
      "& .MuiSelect-select": {
        fontSize: "13px",
        display: "flex",
        alignItems: "center",
      },
    }}
>
  {mappingList.map((item) => (
    <MenuItem key={item.id} value={item.id}
      sx={{
          fontSize: "13px",
          py: 0.5, // reduce vertical padding
        }}>
      <Checkbox
        checked={
          customerDetails.doctorRegistration?.hospitalAddresses?.includes(item.id)
        }
      />
      <ListItemText
        primary={`${item.hospitalName} — ${item.addressLine1}, ${item.addressLine2}`}
               primaryTypographyProps={{
            fontSize: "13px",
          }}
 />
    </MenuItem>
  ))}


  </MDInput>
 {formErrors.hospitalAddresses && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.hospitalAddresses}
  </Typography>
)}

</Grid>


{/* NMC Registered Number */}
<Grid item xs={6}>
  <MDInput
    type="text"
    label="NMC Registered Number"
    fullWidth
    value={customerDetails.doctorRegistration?.nmcRegisteredNumber || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: { ...customerDetails.doctorRegistration, nmcRegisteredNumber: e.target.value },
      })
    }
    inputProps={{ pattern: "[A-Za-z0-9]*" }} // alphanumeric only
    
  />
   {formErrors.nmcRegisteredNumber && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.nmcRegisteredNumber}
            </Typography>
          )}
</Grid>

{/* Year of Registration */}
<Grid item xs={6}>
  <MDInput
    type="date"
    label="Year of Registration"
    fullWidth
    InputLabelProps={{ shrink: true }}
    value={customerDetails.doctorRegistration?.yearOfRegistration || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: { ...customerDetails.doctorRegistration, yearOfRegistration: e.target.value },
      })
    }
    
  />
   {formErrors.yearOfRegistration && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.yearOfRegistration}
            </Typography>
          )}
</Grid>

{/* Council Name */}
{/* Council Name */}



{/* Verification Link */}
<Grid item xs={6}>
  <a
    href="https://www.nmc.org.in/information-desk/indian-medical-register/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ fontSize: "1.1rem" }}
  >
    Verify NMC Registration
  </a>
</Grid>
<Grid item xs={6}>
  <TextField
    select
    label="Verification Status"
    fullWidth
    value={customerDetails.doctorRegistration?.verificationstatus || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: {
          ...customerDetails.doctorRegistration,
          verificationstatus: e.target.value,
        },
      })
    }
    InputProps={{
      style: { height: 45, fontSize: "0.875rem", padding: "0 12px" },
    }}
    InputLabelProps={{
      shrink: true,
      style: { fontSize: "0.875rem" },
    }}
  >
    <MenuItem value="PENDING">Pending</MenuItem>
    <MenuItem value="ACTIVE">Active</MenuItem>
    <MenuItem value="REJECTED">Rejected</MenuItem>
  </TextField>
   {formErrors.verificationstatus && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.verificationstatus}
            </Typography>
          )}
</Grid>

{/* Doctor Type */}
<Grid item xs={6}>
  <MDInput
    select
    label="Doctor Type"
    fullWidth
    value={customerDetails.doctorRegistration?.doctorType || ""}
    onChange={(e) =>
      setCustomerDetails({
        ...customerDetails,
        doctorRegistration: { ...customerDetails.doctorRegistration, doctorType: e.target.value },
      })
    }
     sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    
  >
     {loading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : (
            doctorList.map((doc) => (
              <MenuItem key={doc.doctor_type} value={doc.doctor_type}>
                {doc.doctor_type}
              </MenuItem>
            ))
          )}
        </MDInput>
         {formErrors.doctorType && (
            <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
              {formErrors.doctorType}
            </Typography>
          )}
</Grid>
 </>
            )}
            
</Grid>
 
 {activeStep === 3 && (
  <>
    <Grid item xs={12}>
      <Typography
        variant="h6"
        sx={{ mt: 2, mb: 1, fontWeight: "bold", color: "#1e6a91" }}
      >
        Mandatory Documents
      </Typography>
    </Grid>

    {["Aadhar Card", "PAN Card", "Driving License", "Study Certificate"].map(
      (docName, index) => {
       const doc =
      customerDetails.document.find(
        (d) =>
          d.documentname?.toLowerCase().trim() === docName.toLowerCase().trim()
      ) || {};
    const errors = doc.errors || {};

        return (
          <Grid container spacing={2} key={index} mt={1}>
            {/* Document Name */}
            <Grid item xs={6}>
              <TextField
                label="Document Name"
                fullWidth
                value={docName}
InputProps={{
        readOnly: true, 
      }}                
 sx={{
              "& .MuiInputBase-root": { height: "45px" },
              backgroundColor: "#f9f9f9",
            }}              />
              
            </Grid>

            {/* Document Type */}
            {/* <Grid item xs={6}>
              <MDInput
                label="Document Type"
                fullWidth
                value={doc.documenttype || ""}
                onChange={(e) => {
                  const updatedDocs = [...customerDetails.document];
                  updatedDocs[index] = { ...doc, documenttype: e.target.value };
                  setCustomerDetails({ ...customerDetails, document: updatedDocs });
                }}
              />
            </Grid> */}

            {/* Date of Upload */}
            {/* <Grid item xs={6}>
              <MDInput
                type="date"
                label="Date of Upload"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={doc.dateofupload || ""}
                onChange={(e) => {
                  const updatedDocs = [...customerDetails.document];
                  updatedDocs[index] = { ...doc, dateofupload: e.target.value };
                  setCustomerDetails({ ...customerDetails, document: updatedDocs });
                }}
              />
            </Grid> */}

            {/* File Upload */}
             <Grid item xs={6}>
  <Box display="flex" alignItems="center" gap={1}>
    {/* Hidden File Input */}
    <input
      accept="image/*,.pdf,.doc,.docx"
      type="file"
      id={`file-upload-${index}`}
      style={{ display: "none" }}
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check duplicate
        const duplicate = customerDetails.document.some(
          (d, idx) => d.documentname === docName && idx !== index
        );
        const updatedDocs = [...customerDetails.document];
        if (duplicate) {
          updatedDocs[index] = {
            ...updatedDocs[index],
            errors: { ...updatedDocs[index]?.errors, duplicate: "This document is already uploaded" },
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
          return;
        } else {
          updatedDocs[index] = {
            ...updatedDocs[index],
            documentname: docName,
            errors: { ...updatedDocs[index]?.errors, duplicate: "" },
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        }

        // Read file as base64
        const reader = new FileReader();
        reader.onloadend = () => {
          const updatedDocs = [...customerDetails.document];
          updatedDocs[index] = {
            ...updatedDocs[index],
            documentname: docName,
            imageMeta: file.name,
            image: reader.result.split(",")[1], // store base64
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        };
        reader.readAsDataURL(file);
      }}
    />

    {/* Choose File Button */}
    <label htmlFor={`file-upload-${index}`}>
      <MDButton
        component="span"
        variant="outlined"
        sx={{
          textTransform: "none",
          color: "#1A237E",
          borderColor: "#1A237E",
          height: "40px",
          "&:hover": { backgroundColor: "#e3f2fd" },
        }}
      >
        Choose File
      </MDButton>
    </label>

    {/* File Name Link */}
    {doc.imageMeta && (
      <Typography
        sx={{
          color: "#1A237E",
          cursor: "pointer",
          textDecoration: "underline",
                      fontSize: "13px",

          flexShrink: 0,
        }}
        onClick={() => {
          const ext = doc.imageMeta.split(".").pop().toLowerCase();
          const byteCharacters = atob(doc.image);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Determine MIME type
          let mimeType = "application/octet-stream";
          if (["jpg", "jpeg"].includes(ext)) mimeType = "image/jpeg";
          else if (ext === "png") mimeType = "image/png";
          else if (ext === "gif") mimeType = "image/gif";
          else if (ext === "pdf") mimeType = "application/pdf";
          else if (ext === "doc") mimeType = "application/msword";
          else if (ext === "docx") mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);

          // Open in new tab for images & PDFs, download for Word docs
          if (["jpg", "jpeg", "png", "gif", "pdf"].includes(ext)) {
            window.open(url, "_blank");
          } else {
            const a = document.createElement("a");
            a.href = url;
            a.download = doc.imageMeta;
            a.click();
          }
        }}
      >
        {doc.imageMeta}
      </Typography>
    )}

    {/* Delete Icon */}
    {doc.imageMeta && (
      <IconButton
        size="small"
        color="error"
        onClick={() => {
          const updatedDocs = [...customerDetails.document];
          updatedDocs[index] = {
            ...updatedDocs[index],
            imageMeta: "",
            image: "",
          };
          setCustomerDetails({ ...customerDetails, document: updatedDocs });
        }}
      sx={{ p: 0 }}
        >
          <DeleteIcon sx={{ fontSize: 18 }} />
      </IconButton>
    )}
  </Box>

  {/* Duplicate Error */}
  {doc.errors?.duplicate && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {doc.errors.duplicate}
    </Typography>
  )}
</Grid>

            {/* Aadhaar Verification Button */}
            {docName === "Aadhar Card" && !doc.verified && (
              <Grid item xs={12}>
                <MDButton
                  variant="outlined"
                  onClick={() => {
                    window.open("https://myaadhaar.uidai.gov.in/", "_blank");
                    const updatedDocs = [...customerDetails.document];
                    updatedDocs[index] = { ...doc, verified: true };
                    setCustomerDetails({ ...customerDetails, document: updatedDocs });
                  }}
                  sx={{
                    background:"#1A237E",
                    color: "#fff",
                    "&:hover": { background: "#1A237E" },
                    mt: 1,
                  }}
                >
                  Verify Aadhaar
                </MDButton>
              </Grid>
            )}
          </Grid>
        );
      }
    )}
  </>
)}




  {/* <Grid item xs={12}>
    <MDButton
      variant="contained"
      onClick={handleAddDocument}
      sx={{
        background: "#2e7faeff",
        color: "#fff",
        mt: 1,
      }}
    >
      + Add Another Document
    </MDButton>
  </Grid> */}






       
              </Grid>

              <MDBox mt={3} display="flex" justifyContent="space-between">
  <MDButton
    variant="outlined"
    disabled={activeStep === 0}
    onClick={handleBack}
       sx={{
      background: "#1A237E !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background:"#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }} 

  >
    Back
  </MDButton>

  {activeStep === steps.length - 1 ? (
    <MDButton
      variant="contained"
      onClick={handleSubmit}
sx={{
      background: "#1A237E !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background:"#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}     >
      Submit
    </MDButton>
  ) : (
    <MDButton
      variant="contained"
      onClick={handleNext}
sx={{
      background: "#1A237E !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background:"#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}    >
      Next
    </MDButton>
  )}
</MDBox>

            </form>
          </MDBox>
        </Card>
      
     
    </DashboardLayout>
  );
}

export default CreateDoctorsProfile;